module.exports = __webpack_public_path__ + "img/empty-cart.ba9eeb2e.svg";